import React, { Component } from "react";

class MessageInput extends Component {

  state = {
    message: ""
  }

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.sendMessage()
    }
  }

  changeHandler = (event) => {
    this.setState({message: event.target.value})
  }

  sendMessage = () => {
    if(!this.state.message)
      return;

    this.props.onSubmitMessage(this.state.message)
    this.setState({message: ''})
  }

  render() {
    return(
      <div id="inputContainer">
        <input
          type="text"
          id="messageInput"
          value={this.state.message}
          placeholder={this.props.placeholder}
          onKeyPress={this.handleKeyPress}
          onChange={(event)=>this.changeHandler(event)}
        />
        <button id="sendMessageButton" onClick={this.sendMessage}></button>
      </div>
    )
  }
}

export default MessageInput
